<template>
  <div v-if="show" class="resource-detail">
    <div class="tab-container" :style="examineStatus == -1 ? 'top: 341px' : ''">
      <div
        :class="{ tab: true, 'cur-tab': contentIndex == index }"
        v-for="(item, index) in detailData.content"
        :key="item.id"
        @click="scrollToTab(index)"
      >
        {{ item.typeName }}
      </div>
    </div>
    <div id="content" class="resource-detail-scroll" @scroll="onContentScroll">
      <div class="top-line">
        <div class="small-button" @click="toReturn">返回</div>
        <span class="title">资源详情</span>
      </div>

      <!-- 老师个人中心 -->
      <div v-if="detailType == 3">
        <!-- examineStatus 审核状态 1待审核 0已通过 -1驳回 -->
        <div class="info" :style="examineStatus == -1 ? 'margin-bottom:0' : ''">
          <!-- src="../../images/examinePass.png" -->
          <img
            class="teacher-examineStatus"
            :src="
              require('../../images/' +
                ['examineNoPass', 'examinePass', 'examineWaiting'][
                  Number(examineStatus) + 1
                ] +
                '.png')
            "
            alt=""
          />
          <div style="margin-right: 50px">
            <div class="desc" style="margin-bottom: 7px">
              <!-- 关联图书：{{ detailData.term }} -->
              关联图书：{{ detailData.group1_name }}
              <!-- 关联教材：{{ getTerm(detailData.group1) }} -->
            </div>
            <div class="desc">
              资源标签：
              <!-- {{ detailData.tag }} -->
              <span
                v-for="(item, index) in detailData.tag"
                :key="item"
                :value="item"
              >
                {{ index > 0 ? ' / ' : '' }}{{ item }}
              </span>
            </div>
          </div>
          <div v-if="examineStatus == 0" class="data">
            <div class="data-item">
              <img
                style="width: 20px; height: 14px"
                :src="require('../assets/view.png')"
                alt=""
                class="data-icon"
              />
              {{ getDisplayCount(detailData.views || 0) }}
            </div>
            <div class="data-item">
              <img
                style="width: 17px; height: 16px"
                :src="require('../assets/collect.png')"
                alt=""
                class="data-icon"
              />
              {{ getDisplayCount(detailData.collect || 0) }}
            </div>
            <div class="data-item">
              <img
                style="width: 16px; height: 16px"
                :src="require('../assets/download.png')"
                alt=""
                class="data-icon"
              />
              {{ getDisplayCount(detailData.download || 0) }}
            </div>
          </div>
          <div
            v-if="examineStatus == 1 || examineStatus == -1"
            class="examine-progress"
            :style="detailData.range == 1 ? 'padding-top: 0' : ''"
          >
            <div
              :class="{
                'examine-progress-abs': true,
                'examine-progress-abs2': detailData.range == 1,
              }"
            >
              <img
                class="examine-progress-icon"
                src="../../images/examineProgressIcon.png"
                alt=""
              />
              <div class="examine-progress-title">审核进度</div>
            </div>
            <div class="desc" style="margin-bottom: 7px">
              提交时间：{{ detailData.created_at }}
            </div>
            <div class="desc" style="margin-bottom: 7px">
              校级管理员审核：{{
                examineStatus == -1 && detailData.range == 1
                  ? '已驳回'
                  : detailData.verify1_at || '待审核'
              }}
            </div>
            <div v-if="detailData.range == 0" class="desc">
              超级管理员审核：{{
                examineStatus == -1
                  ? '已驳回'
                  : detailData.verify2_at || '待审核'
              }}
            </div>
          </div>

          <div v-if="examineStatus == 0" class="teacher-button-container">
            <el-button
              class="info-button"
              type="primary"
              style="width: 120px"
              @click="
                () => {
                  this.$emit('toEdit')
                }
              "
              >编辑资源</el-button
            >
            <div class="teacher-button-des">
              更新时间：{{ detailData.updated_at }}
            </div>
          </div>
        </div>
        <div v-if="examineStatus == -1" class="nopass-reason-box">
          <div class="nopass-reason">
            驳回原因：{{
              detailData.last_verify && detailData.last_verify.describe
            }}
            <el-button
              class="info-button"
              type="primary"
              style="width: 120px"
              @click="
                () => {
                  this.$emit('toEdit')
                }
              "
              >编辑资源</el-button
            >
          </div>
        </div>
      </div>

      <!-- 审核资源头部 -->
      <div v-if="detailType == 2">
        <!-- examineStatus 审核状态 1待审核 0已通过 -1驳回 -->
        <div class="info" :style="examineStatus == -1 ? 'margin-bottom:0' : ''">
          <img
            class="avatar"
            :src="
              detailData.created_user.avatar ||
              require('../../images/teacherCover.png')
            "
            alt=""
          />
          <!-- src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fsafe-img.xhscdn.com%2Fbw1%2Fbf6fe5f0-4e5c-4dd1-9545-f58151164f0c%3FimageView2%2F2%2Fw%2F1080%2Fformat%2Fjpg&refer=http%3A%2F%2Fsafe-img.xhscdn.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1683272195&t=e17bd0b2ab4d88505fb83a4d209f63ed" -->
          <div style="margin-right: 29px">
            <!-- <div class="name" style="margin-bottom: 8px">
              {{ detailData.created_user.nick_name || detailData.created_user }}
            </div> -->
            <div
              v-if="detailData.is_gfpt != 1"
              class="name"
              style="margin-bottom: 8px"
            >
              <!-- {{ detailData.school_name }} -->
              {{ detailData.created_user.nick_name || detailData.created_user }}
            </div>
            <div
              v-if="detailData.is_gfpt == 1"
              class="name"
              style="margin-bottom: 8px"
            >
              <!-- 官方配套资源 -->
              配套资源
            </div>
            <div v-if="detailData.is_gfpt != 1" class="name">
              {{ detailData.school_name }}
            </div>
          </div>

          <div
            v-if="isSearch && detailData.is_gfpt != 1"
            style="margin-right: 50px"
          >
            <div
              v-if="role !== 'admin' && detailData.created_by != this.uid"
              class="follow"
              @click="changeFollowState"
            >
              {{ detailData.follow ? '取关' : '关注' }}
            </div>
            <div class="link" @click="toHome">查看主页</div>
          </div>

          <div style="margin-right: 50px; padding-top: 22px">
            <div class="desc" style="margin-bottom: 7px">
              <!-- 关联图书：{{ detailData.term }} -->
              关联图书：{{ detailData.group1_name }}
            </div>
            <div class="desc">
              资源标签：
              <!-- {{ detailData.tag }} -->
              <span
                v-for="(item, index) in detailData.tag"
                :key="item"
                :value="item"
              >
                {{ index > 0 ? ' / ' : '' }}{{ item }}
              </span>
            </div>
          </div>

          <div v-if="isYNZY || isSearch" class="data">
            <div class="data-item">
              <img
                style="width: 20px; height: 14px"
                :src="require('../assets/view.png')"
                alt=""
                class="data-icon"
              />
              {{ getDisplayCount(detailData.views || 0) }}
            </div>
            <div class="data-item">
              <img
                style="width: 17px; height: 16px"
                :src="require('../assets/collect.png')"
                alt=""
                class="data-icon"
              />
              {{ getDisplayCount(detailData.collect || 0) }}
            </div>
            <div class="data-item">
              <img
                style="width: 16px; height: 16px"
                :src="require('../assets/download.png')"
                alt=""
                class="data-icon"
              />
              {{ getDisplayCount(detailData.download || 0) }}
            </div>
          </div>

          <div
            v-if="examineStatus == 0"
            class="examine-progress"
            :style="examineRange == 1 ? 'padding-top: 25px' : ''"
          >
            <div
              :class="{
                'examine-progress-abs': true,
                'examine-progress-abs2': examineRange == 1,
              }"
            >
              <img
                class="examine-progress-icon"
                src="../../images/examineProgressIcon.png"
                alt=""
              />
              <div class="examine-progress-title">审核进度</div>
            </div>
            <div class="desc" style="margin-bottom: 7px">
              提交时间：{{ detailData.created_at }}
            </div>
            <div class="desc" style="margin-bottom: 7px">
              校级管理员审核：{{ detailData.verify1_at }}
            </div>
            <div v-if="examineRange == 0" class="desc">
              超级管理员审核：{{ detailData.verify2_at || '待审核' }}
            </div>
          </div>
          <div v-if="examineStatus == -1" class="examine-progress">
            <div class="examine-progress-abs examine-progress-abs-nopass">
              <img
                class="examine-progress-icon"
                src="../../images/examineProgressIcon.png"
                alt=""
              />
              <div class="examine-progress-title">审核进度</div>
            </div>
            <div class="desc" style="margin-bottom: 7px">
              提交时间：{{ detailData.created_at }}
            </div>
            <div class="desc">驳回时间：{{ detailData.created_at }}</div>
          </div>
          <div
            v-if="examineStatus == 1"
            :style="
              examineRole == 1
                ? 'margin-right: 50px; padding-top: 25px'
                : 'margin-right: 50px; padding-top: 50px'
            "
          >
            <div class="desc">提交时间：{{ detailData.created_at }}</div>
            <div v-if="examineRole == 1" class="desc" style="margin-top: 7px">
              校级管理员审核时间：{{ detailData.verify1_at }}
            </div>
          </div>
          <div v-if="examineStatus == 1" class="button-container">
            <el-button
              class="info-button"
              type="primary"
              style="margin-right: 20px; width: 120px"
              @click="pass(index)"
              >审核通过</el-button
            >
            <el-button style="width: 120px" @click="noPass(index)"
              >驳回</el-button
            >
          </div>

          <div v-if="isSearch" class="button-container">
            <el-button
              v-if="role != 'admin'"
              class="info-button"
              type="primary"
              style="margin-right: 20px"
              @click="changeCollectStatus"
              >{{ detailData.is_collect ? '取消收藏' : '收藏资源' }}</el-button
            >
            <el-button
              v-if="role == 'admin' && detailData.is_gfpt"
              class="info-button"
              type="primary"
              style="width: 120px"
              @click="
                () => {
                  this.$emit('toEdit')
                }
              "
              >编辑资源</el-button
            >
            <el-button
              v-if="!isDaodu"
              class="info-button"
              type="primary"
              @click="toDownload"
              >下载资源</el-button
            >
          </div>
        </div>
        <div v-if="examineStatus == -1" class="nopass-reason-box">
          <div class="nopass-reason">
            驳回原因：{{
              detailData.last_verify && detailData.last_verify.describe
            }}
          </div>
        </div>
      </div>

      <!-- 资源详情 -->
      <div v-if="detailType == 1" class="info">
        <img
          v-if="origin == 1"
          class="avatar"
          :src="
            detailData.created_user.avatar ||
            require('../../images/teacherCover.png')
          "
          alt=""
        />
        <!-- :src="detailData.created_user.avatar || 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fsafe-img.xhscdn.com%2Fbw1%2Fbf6fe5f0-4e5c-4dd1-9545-f58151164f0c%3FimageView2%2F2%2Fw%2F1080%2Fformat%2Fjpg&refer=http%3A%2F%2Fsafe-img.xhscdn.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1683272195&t=e17bd0b2ab4d88505fb83a4d209f63ed'" -->
        <img
          v-if="origin == 2"
          class="avatar"
          :src="require('../assets/gfpt.png')"
          alt=""
        />
        <div style="margin-right: 29px">
          <div v-if="origin == 1" class="name" style="margin-bottom: 8px">
            <!-- {{ detailData.author }} -->
            {{ detailData.created_user.nick_name }}
          </div>
          <div v-if="origin == 1" class="name">
            {{ detailData.school_name }}
          </div>
          <!-- <div v-if="origin == 2" class="name">官方配套资源</div> -->
          <div v-if="origin == 2" class="name">配套资源</div>
        </div>
        <div v-if="origin == 1" style="margin-right: 50px">
          <div
            v-if="role !== 'admin' && detailData.created_by != this.uid"
            class="follow"
            @click="changeFollowState"
          >
            {{ detailData.follow ? '取关' : '关注' }}
          </div>
          <div class="link" @click="toHome">查看主页</div>
        </div>
        <div style="margin-right: 50px; padding-top: 0px">
          <div class="desc" style="margin-bottom: 7px">
            资源标签：
            <!-- {{ detailData.tag }} -->
            <span
              v-for="(item, index) in detailData.tag"
              :key="item"
              :value="item"
            >
              {{ index > 0 ? ' / ' : '' }}{{ item }}
            </span>
          </div>
          <div class="desc">更新时间：{{ detailData.updated_at }}</div>
        </div>
        <div class="data">
          <div class="data-item">
            <img
              style="width: 20px; height: 14px"
              :src="require('../assets/view.png')"
              alt=""
              class="data-icon"
            />
            {{ getDisplayCount(detailData.views || 0) }}
          </div>
          <div class="data-item">
            <img
              style="width: 17px; height: 16px"
              :src="require('../assets/collect.png')"
              alt=""
              class="data-icon"
            />
            {{ getDisplayCount(detailData.collect || 0) }}
          </div>
          <div class="data-item">
            <img
              style="width: 16px; height: 16px"
              :src="require('../assets/download.png')"
              alt=""
              class="data-icon"
            />
            {{ getDisplayCount(detailData.download || 0) }}
          </div>
        </div>
        <div v-if="detailType == 1" class="button-container">
          <el-button
            v-if="role != 'admin'"
            class="info-button"
            type="primary"
            style="margin-right: 20px"
            @click="changeCollectStatus"
            >{{ detailData.is_collect ? '取消收藏' : '收藏资源' }}</el-button
          >
          <el-button
            v-if="role == 'admin' && detailData.is_gfpt"
            class="info-button"
            type="primary"
            style="width: 120px"
            @click="
              () => {
                this.$emit('toEdit')
              }
            "
            >编辑资源</el-button
          >
          <el-button
            v-if="!isDaodu"
            class="info-button"
            type="primary"
            @click="toDownload"
            >下载资源</el-button
          >
        </div>
      </div>

      <div class="content">
        <div class="resource-title">{{ detailData.title }}</div>
        <div
          :id="`content${index}`"
          :class="{
            'doc-box': item.type == 1,
            'doc-box-ppt': item.type == 2,
            'doc-box-pdf': item.type == 3,
            'doc-box-video': item.type == 6,
          }"
          v-for="(item, index) in detailData.content"
          :key="index"
        >
          <div
            v-if="item.type == 1 || item.type == 2 || item.type == 3"
            class="doc-header"
          >
            {{ item.fileName }}
          </div>
          <iframe
            v-if="item.type == 1 || item.type == 2"
            class="doc"
            :src="`https://view.officeapps.live.com/op/view.aspx?src=${item.url}`"
            frameborder="0"
          ></iframe>
          <iframe
            v-if="item.type == 3"
            class="doc"
            :src="`https://www.yeykcfa.cn/viewer/web/viewer.html?file=${item.url}`"
            frameborder="0"
          ></iframe>
          <!-- :src="`https://www.whtlkj.net/pdfjs/web/viewer.html?file=${item.url}`" -->
          <div class="pdf-block" v-if="item.type == 3">
            <div class="white-block"></div>
          </div>
          <div v-if="item.type == 2" class="doc-footer"></div>
          <div v-if="item.type == 4" class="video-container">
            <div class="video-header">{{ item.fileName }}</div>
            <video
              class="content-video"
              :controlsList="isDaodu ? 'nodownload' : ''"
              :src="item.url"
              controls
            ></video>
          </div>
          <div v-if="item.type == 5" class="img-container">
            <el-image
              :id="`img${index}`"
              class="content-img"
              v-for="(img, index) in item.imgs"
              :key="img"
              :src="img"
              alt=""
              :preview-src-list="item.imgs"
              @click="onPreview"
              @load="onImgLoad(item, $event, index)"
              draggable="false"
            />
          </div>
          <div v-if="item.type == 6" class="player">
            <img
              class="player-icon"
              :src="require('../assets/sound.png')"
              alt=""
            />
            <div class="player-info">
              <div class="player-name">{{ item.fileName }}</div>
              <div class="player-time">{{ getFormatTime(duration) }}</div>
            </div>
            <img
              class="player-button"
              :src="
                playing
                  ? require('../assets/pause.png')
                  : require('../assets/play.png')
              "
              @click="changePlayState"
            />
            <audio id="player" :src="item.url"></audio>
          </div>
        </div>
      </div>
    </div>

    <!-- 下载 -->
    <div v-if="downloadShow" class="download-container">
      <div class="top-line">
        <!-- <div class="small-button" @click="downloadShow = false">返回</div> -->
        <div class="small-button" @click="this.closeDownload">返回</div>
        
        <span class="title">下载资源</span>
      </div>
      <div class="download-main">
        <div class="download-title">请选择要下载的源文件：</div>
        <div
          class="download-line"
          v-for="(item, index) in downloadList"
          :key="index"
        >
          <div class="download-button">
            <img
              class="download-pic"
              :src="require('../assets/downloadIcon.png')"
              alt=""
            />
            <img
              class="download-pic-hover"
              :src="require('../assets/download-hover.png')"
              alt=""
            />
            <div
              v-if="item.type == 5"
              class="download-href"
              @click="toDownloadPicZip(item.ids)"
            ></div>
            <!-- <a
              class="download-href"
              v-else
              target="_blank"
              :href="item.url"
              :download="item.fileName"
              @click="onDownloadOne(item)"
            ></a> -->
            <div
              class="download-href"
              v-else
              @click="onDownloadOne(item)"
            ></div>
          </div>
          <img
            class="download-icon"
            :src="downloadIconList[item.type]"
            alt=""
          />
          {{ item.fileName }}
        </div>
        <div class="download-button-all" @click="toDownloadAll">下载全部</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  downloadAll,
  downloadFile,
  collect,
  saveDownloadRecord,
  follow,
} from '../api/api'
export default {
  name: 'ResourceDetail',
  props: {
    detailType: {
      // 类型  1普通  2审核(校内资源、搜索)  3老师个人中心
      type: String,
      default: '1',
    },
    isYNZY: Boolean, // 是否为校内资源
    isSearch: Boolean, // 是否为搜索
    // isExamine: Boolean, // 是否为审核
    examineRole: Number, // 身份 1超管 2老师 3学校
    examineStatus: Number, // 审核状态 1待审核 0已通过 -1驳回
    examineRange: Number, // (学校端)审核范围 0平台可见 1校内资源

    show: Boolean,
    origin: Number, // 1-教材配套资源 2-官方配套资源
    detailData: {
      type: Object,
      default: () => ({
        title: '欣欣老师',
        school_name: '中心幼儿园',
        tag: '教学素材',
        updated_at: '2023-03-17 12:0',
        views: 45000,
        collect: 50000,
        download: 65000,
        content: [
          {
            id: 1,
            typeName: 'word',
            type: 1,
            fileName: '寻找春天的足迹.doc',
            url: 'https://whtlkj.oss-cn-beijing.aliyuncs.com/qlxhj/20230404/test.docx',
          },
          {
            id: 2,
            typeName: 'ppt',
            type: 2,
            fileName: '寻找春天的足迹.pptx',
            url: 'https://whtlkj.oss-cn-beijing.aliyuncs.com/qlxhj/20230404/test1.pptx',
          },
          {
            id: 3,
            typeName: 'pdf',
            type: 3,
            fileName: '寻找春天的足迹.pdf',
            url: 'https://whtlkj.oss-cn-beijing.aliyuncs.com/qlxhj/20230404/test.pdf',
          },
          {
            id: 4,
            typeName: '视频',
            type: 4,
            fileName: '寻找春天的足迹.mp4',
            url: 'http://meiyukc.oss-cn-shenzhen.aliyuncs.com/meiyu/admin/1678876434874.mp4',
          },
          {
            id: 5,
            typeName: '图片',
            type: 5,
            imgs: [
              'http://meiyukc.oss-cn-shenzhen.aliyuncs.com/meiyu/admin/1678883306942.png',
              'http://meiyukc.oss-cn-shenzhen.aliyuncs.com/meiyu/admin/1678883306942.png',
            ],
          },
          {
            id: 6,
            typeName: '音频',
            type: 6,
            fileName: '童话镇.mp3',
            url: 'https://ms-yey.oss-cn-shanghai.aliyuncs.com/yey/20230410/168113021785445284.mp3',
          },
        ],
      }),
    },
  },
  watch: {
    show: function (val) {
      if (val) {
        // 组件展示时 循环获取元素高度，用于左侧tag展示
        this.interval = setInterval(() => {
          if (this.contentTops.length == 0) {
            this.getDocTop()
          } else {
            clearInterval(this.interval)
          }
        }, 500)
        // 初始化音频播放器
        setTimeout(() => {
          this.player = document.getElementById('player')
          if (this.player) {
            this.duration = this.player.duration
          }
        }, 1000)
      } else {
        // 隐藏时重置tag相关数据，清除定时器
        this.contentIndex = 0
        this.contentTops = []
        clearInterval(this.interval)
      }
    },
    detailData: function (val) {
      console.log('传值进来', val)
      if (val.group1_name.indexOf('导读') == -1) {
        console.log('不是导读')
        this.isDaodu = false
      } else {
        this.isDaodu = true
      }
      // 做错误处理，防止后台返回null
      if (!val.created_user) {
        this.detailData.created_user = {
          avatar: null,
          nick_name: '',
        }
      }
      let content = []
      let downloadList = []
      let nameDict = {
        word: 'word',
        doc: 'word',
        docx: 'word',
        wps: 'word',
        ppt: 'ppt',
        pptx: 'ppt',
        pdf: 'pdf',
        mp4: '视频',
        png: '图片',
        jpg: '图片',
        jpeg: '图片',
        mp3: '音频',
      }
      let typeDict = {
        word: '1',
        doc: '1',
        docx: '1',
        wps: '1',
        ppt: '2',
        pptx: '2',
        pdf: '3',
        mp4: '4',
        png: '5',
        jpg: '5',
        jpeg: '5',
        mp3: '6',
      }
      let imgsObj = { imgs: [], ids: [], size: [] }
      val.urls.forEach((item) => {
        if (
          typeDict[
            item.file_name
              .split('.')
              [item.file_name.split('.').length - 1].toLowerCase()
          ] == '5'
        ) {
          imgsObj.typeName =
            nameDict[
              item.file_name
                .split('.')
                [item.file_name.split('.').length - 1].toLowerCase()
            ]
          imgsObj.type =
            typeDict[
              item.file_name
                .split('.')
                [item.file_name.split('.').length - 1].toLowerCase()
            ]
          imgsObj.fileName = item.file_name
          imgsObj.ids.push(item.id)
          imgsObj.imgs.push(item.url)
          imgsObj.size.push({ width: 300, height: 160 })
        } else {
          content.push({
            typeName:
              nameDict[
                item.file_name
                  .split('.')
                  [item.file_name.split('.').length - 1].toLowerCase()
              ],
            type: typeDict[
              item.file_name
                .split('.')
                [item.file_name.split('.').length - 1].toLowerCase()
            ],
            fileName: item.file_name,
            id: item.id,
            url: item.url,
          })
          downloadList.push({
            typeName:
              nameDict[
                item.file_name
                  .split('.')
                  [item.file_name.split('.').length - 1].toLowerCase()
              ],
            type: typeDict[
              item.file_name
                .split('.')
                [item.file_name.split('.').length - 1].toLowerCase()
            ],
            fileName: item.file_name,
            id: item.id,
            url: item.url,
          })
        }
      })
      if (imgsObj.imgs.length > 0) {
        content.push(imgsObj)
        downloadList.push({
          typeName: imgsObj.typeName,
          type: imgsObj.type,
          fileName: '图片素材包.zip',
          ids: imgsObj.ids,
          imgs: imgsObj.imgs,
        })
      }
      this.downloadList = downloadList
      console.log('downloadlist', downloadList)
      this.detailData.content = content
    },
  },
  data: () => ({
    isDaodu: true,
    role: 'admin',
    uid: 0,
    contentTops: [],
    contentIndex: 0,
    player: null,
    duration: 0,
    playing: false,
    downloadShow: false,
    downloadIconList: [
      '',
      require('../../images/word.png'),
      require('../../images/ppt.png'),
      require('../../images/pdf.png'),
      require('../../images/mp4.png'),
      require('../../images/pic.png'),
      require('../../images/mp3.png'),
    ],
    downloadList: [],
    interval: null,
  }),
  async mounted() {
    let user = JSON.parse(localStorage.getItem('yey-user'))
    this.role = user.role
    this.uid = user.id
  },
  destroyed() {
    clearInterval(this.interval)
    if (this.player && this.playing) {
      this.player.pause()
      this.playing = false
    }
  },
  methods: {
    noPass() {
      this.$emit('toNoPass')
    },
    pass() {
      this.$emit('toPass')
    },
    getFormatTime(duration) {
      let minute = Math.floor(duration / 60)
      let second = Math.floor(duration % 60)
      return `${minute}分${second}秒`
    },
    getDisplayCount(num) {
      if (num > 9999) {
        return Math.floor(num / 1000) / 10 + 'w'
      } else {
        return num
      }
    },
    toReturn() {
      if (this.player && this.playing) {
        this.player.pause()
        this.playing = false
      }
      if (this.$route.query.id) {
        this.$router.back()
      } else {
        sessionStorage.removeItem('yey-detail')
        sessionStorage.removeItem('yey-searchDetail')
        sessionStorage.removeItem('yey-schoolResourceDetail')
        this.$emit('onReturn')
      }
    },
    // 获取文档到顶部距离
    getDocTop() {
      let tops = []
      this.detailData.content.forEach((item, index) => {
        tops.push(document.getElementById('content' + index).offsetTop)
      })
      this.contentTops = tops
    },
    onContentScroll(e) {
      if (this.contentTops.length == 0) {
        this.getDocTop()
      }
      let contentIndex = 0
      this.contentTops.forEach((item, index) => {
        if (e.target.scrollTop > item) {
          contentIndex = index
        }
      })
      this.contentIndex = contentIndex
      if (
        e.target.offsetHeight + e.target.scrollTop >=
        e.target.scrollHeight - 100
      ) {
        this.contentIndex = this.detailData.content.length - 1
      }
    },
    scrollToTab(index) {
      document
        .getElementById('content')
        .scrollTo(0, this.contentTops[index] + 200)
    },
    changePlayState() {
      if (this.playing) {
        this.player.pause()
        this.playing = false
      } else {
        this.player.play()
        this.playing = true
      }
    },
    // 显示下载页面
    toDownload() {
      this.downloadShow = true
    },
    closeDownload() {
      this.$emit('updateDownload')
      this.downloadShow = false
    },
    onDownloadOne(item) {
      saveDownloadRecord([item.id])
      const x = new XMLHttpRequest()
      x.open('GET', item.url, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.target = 'blank'
        a.download = item.fileName
        a.click()
        a.remove()
      }
      x.send()
    },
    toDownloadPicZip(ids) {
      downloadFile(ids).then((res) => {
        const blobUrl = URL.createObjectURL(res.data)
        const a = document.createElement('a')
        a.href = blobUrl
        a.download = '图片素材包.zip'
        a.click()
        URL.revokeObjectURL(blobUrl)
        saveDownloadRecord(ids)
      })
    },
    // 开始下载
    toDownloadAll() {
      const loading = this.$loading({
        lock: true,
        text: '下载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      downloadAll(this.detailData.id).then((res) => {
        console.log('下载数据', res)
        loading.close()
        // const blob = new Blob([res.data])
        const blobUrl = URL.createObjectURL(res.data)
        const a = document.createElement('a')
        a.href = blobUrl
        a.download = `${this.detailData.title}-资源包.zip`
        a.click()
        URL.revokeObjectURL(blobUrl)
      })
    },
    changeCollectStatus() {
      collect(this.detailData.id).then((res) => {
        console.log(res)
        if (this.detailData.is_collect) {
          this.$message({
            message: '取消收藏成功！',
            type: 'success',
          })
          this.$emit('updateCollect', false)
        } else {
          this.$message({
            message: '收藏成功！',
            type: 'success',
          })
          this.$emit('updateCollect', true)
        }
      })
    },
    changeFollowState() {
      follow(this.detailData.created_by).then((res) => {
        if (this.detailData.follow) {
          this.$message({
            message: '取消关注成功！',
            type: 'success',
          })
          this.$emit('updateFollow', false)
        } else {
          this.$message({
            message: '关注成功！',
            type: 'success',
          })
          this.$emit('updateFollow', true)
        }
      })
    },
    toHome() {
      if (this.detailData.created_by == this.uid) {
        sessionStorage.setItem('yey-mineMenuIndex', 0)
        sessionStorage.setItem('yey-teacherResourceIndex', 0)
        this.$router.push('mine')
      } else {
        this.$router.push(`authorIndex?id=${this.detailData.created_by}`)
      }
    },
    onImgLoad(item, e, index) {
      document.getElementById(`img${index}`).style.width =
        (160 * e.target.width) / e.target.height
    },
    onPreview() {
      setTimeout(() => {
        document.getElementsByClassName(
          'el-image-viewer__img'
        )[0].oncontextmenu = function () {
          return false
        }
        // 上下一张的时候重新绑定事件
        document.getElementsByClassName('el-image-viewer__next')[0].onclick =
          function () {
            setTimeout(() => {
              document.getElementsByClassName(
                'el-image-viewer__img'
              )[0].oncontextmenu = function () {
                return false
              }
            }, 100)
          }
        document.getElementsByClassName('el-image-viewer__prev')[0].onclick =
          function () {
            setTimeout(() => {
              document.getElementsByClassName(
                'el-image-viewer__img'
              )[0].oncontextmenu = function () {
                return false
              }
            }, 100)
          }
      }, 100)
    },
  },
}
</script>

<style lang="less" scoped>
.resource-detail {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: calc(100vh - 100px);

  .teacher-examineStatus {
    width: 112px;
    height: 112px;
    margin: 0 20px 0 30px;
  }
  // height: 166px;

  .teacher-button-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    position: absolute;
    right: 30px;
    top: 50px;
    .info-button {
      background-color: #27b2fe;
    }
    .teacher-button-des {
      margin-top: 11px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #555555;
      line-height: 14px;
    }
  }

  .examine-progress {
    position: relative;
    padding-left: 107px;
    .examine-progress-abs {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      height: 72px;
      padding-right: 10px;
      border-right: 1px solid #ccc;
      .examine-progress-icon {
        margin-right: 4px;
        width: 18px;
        height: 18px;
      }
      .examine-progress-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #333333;
        line-height: 22px;
      }
    }

    .examine-progress-abs1 {
      top: 24px;
      height: 48px;
    }
    .examine-progress-abs2 {
      height: 48px;
    }
    .examine-progress-abs-nopass {
      height: 48px;
    }
  }
  .nopass-reason-box {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 30px;
    background-color: #fff;
    margin-bottom: 10px;
    box-sizing: border-box;
  }
  .nopass-reason {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 30px 0;
    border-top: 1px solid #ccc;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fc6356;
    line-height: 24px;
  }

  .resource-detail-scroll {
    box-sizing: border-box;
    width: 100%;
    height: calc(100vh - 100px);
    padding: 0 20px;
    overflow: auto;
  }
  .tab-container {
    position: absolute;
    left: 20px;
    top: 257px;
    padding-top: 10px;
    z-index: 3;
    .tab {
      width: 64px;
      height: 28px;
      margin-top: 20px;
      background: #ffffff;
      text-align: center;
      line-height: 28px;
      font-size: 16px;
      color: #999;
      box-shadow: 2px 0px 10px 0px rgba(0, 0, 0, 0.09);
      border-radius: 0px 17px 17px 0px;
      user-select: none;
      cursor: pointer;
    }
    .cur-tab {
      color: #10b3ff;
    }
  }
  .top-line {
    display: flex;
    height: 81px;
    align-items: center;
  }
  .small-button {
    width: 56px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #00aeff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #00aeff;
    user-select: none;
    cursor: pointer;
  }
  .title {
    font-size: 18px;
    color: #4d4d4d;
    margin-left: 20px;
  }
  .info {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 166px;
    background-color: #fff;
    margin-bottom: 10px;
    .avatar {
      width: 112px;
      height: 112px;
      border-radius: 50%;
      margin: 0 20px;
    }
    .name {
      font-size: 20px;
      color: #1a1a1a;
    }
    .follow {
      width: 64px;
      height: 28px;
      margin-bottom: 14px;
      text-align: center;
      line-height: 28px;
      color: #fff;
      font-size: 16px;
      background: #10b3ff;
      border-radius: 17px;
      user-select: none;
      cursor: pointer;
    }
    .link {
      font-size: 16px;
      color: #10b3ff;
      text-decoration: underline;
      user-select: none;
      cursor: pointer;
    }
    .desc {
      font-size: 14px;
      color: #666;
    }
    .data {
      display: flex;
      padding-top: 24px;
      .data-item {
        display: flex;
        align-items: center;
        flex-flow: row nowrap;
        margin-right: 33px;
        font-size: 14px;
        color: #4c4c4c;
        &:last-child {
          margin-right: 0;
        }
      }
      .data-icon {
        margin-right: 4px;
      }
    }
    .button-container {
      position: absolute;
      right: 30px;
      top: 63px;
      .info-button {
        background-color: #27b2fe;
      }
    }
  }
  .content {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    min-height: calc(100vh - 377px);
    padding: 20px 30px 30px 102px;
    background: #fefefe;
  }
  .resource-title {
    margin-bottom: 20px;
    padding-left: 24px;
    line-height: 28px;
    font-size: 20px;
    color: #4d4d4d;
    font-weight: 500;
  }
  .doc-box {
    position: relative;
    width: 1046px;
    height: 685px;
    margin-bottom: 20px;
    overflow: hidden;
    .doc {
      position: absolute;
      top: -64px;
      left: 0;
      width: 1046px;
      height: 749px;
    }
    .doc-header {
      position: absolute;
      top: 0;
      left: 0;
      box-sizing: border-box;
      width: 1046px;
      height: 35px;
      padding-left: 26px;
      line-height: 35px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #e7e5e4;
      background: #f8f7f6;
      z-index: 2;
    }
  }
  .doc-box-ppt {
    position: relative;
    width: 1046px;
    height: 685px;
    margin-bottom: 20px;
    overflow: hidden;
    .doc-footer {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 300px;
      height: 22px;
      background-color: #444444;
      border-top: 1px solid #555555;
    }
    .doc {
      position: absolute;
      top: -60px;
      left: 0;
      width: 1046px;
      height: 745px;
    }
    .doc-header {
      position: absolute;
      top: 0;
      left: 0;
      box-sizing: border-box;
      width: 1046px;
      height: 50px;
      padding-left: 26px;
      line-height: 50px;
      font-size: 14px;
      color: #b3b3b3;
      background: #323335;
      z-index: 2;
    }
  }

  .doc-box-pdf {
    position: relative;
    width: 1046px;
    height: 735px;
    margin-bottom: 20px;
    .doc {
      position: absolute;
      top: 40px;
      width: 1046px;
      height: 685px;
    }
    .doc-header {
      position: absolute;
      top: 0;
      left: 0;
      box-sizing: border-box;
      width: 1046px;
      height: 40px;
      padding-left: 26px;
      line-height: 40px;
      font-size: 14px;
      color: #666;
      background: #f8f8fa;
      z-index: 2;
    }
  }
  .pdf-block {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 1046px;
    height: 10px;
    background-color: rgb(212, 212, 215);
    .white-block {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 17px;
      height: 10px;
      background-color: rgb(241, 241, 241);
    }
  }
  .video-container {
    box-sizing: border-box;
    width: 784px;
    height: 486px;
    margin-bottom: 20px;
    padding: 0 20px 20px;
    background-color: #f8f8fa;
    .video-header {
      box-sizing: border-box;
      width: 784px;
      height: 48px;
      margin-left: -20px;
      padding-left: 26px;
      line-height: 48px;
      font-size: 14px;
      color: #4d4d4d;
      background: #f8f8fa;
      border-radius: 1px;
    }
  }
  .content-video {
    width: 744px;
    height: 419px;
    border-radius: 10px;
  }
  .img-container {
    display: flex;
    flex-flow: row wrap;
    padding: 20px 0 5px;
    margin-bottom: 20px;
    .content-img {
      width: auto;
      height: 160px;
      border-radius: 10px;
      margin-right: 15px;
      margin-bottom: 15px;
    }
  }
  .doc-box-video {
    position: relative;
    height: 80px;
  }
  .player {
    position: absolute;
    left: 0;
    display: flex;
    align-items: center;
    padding: 13px 20px;
    border-radius: 40px;
    background: #f1f1f1;
    user-select: none;
    cursor: pointer;
  }
  .player-icon {
    width: 24px;
    height: 26px;
    margin-left: 5px;
    margin-right: 24px;
  }
  .player-info {
    margin-right: 47px;
    .player-name {
      margin-bottom: 7px;
      line-height: 22px;
      font-size: 16px;
      color: #4d4d4d;
    }
    .player-time {
      color: #999;
      font-size: 14px;
    }
  }
  .player-button {
    width: 56px;
    height: 56px;
  }

  .download-container {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 4;
    box-sizing: border-box;
    width: 100%;
    height: calc(100vh - 100px);
    padding: 0 20px 40px;
    overflow: auto;
    background-color: #f2f5f8;
  }
  .download-main {
    min-height: calc(100vh - 260px);
    padding: 30px 40px;
    background: #fff;
    .download-title {
      font-size: 20px;
      color: #1a1a1a;
    }
    .download-line {
      display: flex;
      align-items: center;
      margin-top: 28px;
    }
    .download-button {
      position: relative;
      width: 18px;
      height: 18px;
      margin-right: 22px;
      .download-pic {
        width: 18px;
        height: 18px;
      }
      .download-pic-hover {
        display: none;
        width: 18px;
        height: 18px;
      }
      &:hover {
        .download-pic {
          display: none;
          width: 18px;
          height: 18px;
        }
        .download-pic-hover {
          display: block;
          width: 18px;
          height: 18px;
        }
      }
      .download-href {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        opacity: 0;
        user-select: none;
        cursor: pointer;
      }
    }
    .download-icon {
      width: 18px;
      height: 18px;
      margin-right: 4px;
    }
    .download-button-all {
      width: 121px;
      height: 40px;
      margin-top: 50px;
      text-align: center;
      line-height: 40px;
      font-size: 18px;
      color: #fff;
      background: #27b2fe;
      border-radius: 20px;
      cursor: pointer;
      user-select: none;
    }
  }
}
</style>
